<!--
 * @Author:
 * @LastEditTime: 2022-04-18 16:28:29
 * @Description: 新增、编辑api
-->
<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <div class="flex justify-between items-center">
        <span
          v-if="['update', 'create', 'approve'].includes(operateApiProps.editType)"
          class="border-l-3 border-color-primary pl-10px text-18px"
          >{{ operateApiProps.title }}</span
        >
        <div v-else>
          <el-page-header @back="$emit('cancel')" :content="operateApiProps.title">
          </el-page-header>
        </div>
        <el-button v-if="$hasAccess('readFlow') && flowTaskId" @click="viewFlow"
          >查看流程</el-button
        >
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-form
          size="mini"
          label-width="150px"
          v-loading="parentFormLoading"
          :rules="parentApiRules"
          ref="parentForm"
          :model="parentApiForm"
        >
          <el-row class="px-20px">
            <div class="flex items-center ml-10px mb-5px">
              <span class="border-l-3 border-color-primary pl-10px text-18px">基本信息</span>
            </div>
            <!-- <el-divider content-position="left">
              <span class="text-16px font-600">基本信息</span>
            </el-divider> -->
            <el-col :span="8">
              <el-form-item label="单位名称" prop="orgName">
                <el-input
                  class="w-full"
                  v-model="parentApiForm.orgName"
                  :readonly="operateApiProps.editType === 'edit'"
                  placeholder="请输入单位名称"
                  size="small"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单位简称" prop="orgShortName">
                <el-input
                  class="!w-full"
                  v-model="parentApiForm.orgShortName"
                  placeholder="请输入单位简称"
                  size="small"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人电话" prop="phoneNumber">
                <el-input
                  class="!w-full"
                  v-model="parentApiForm.phoneNumber"
                  placeholder="请输入联系人电话"
                  size="small"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单位负责人" prop="orgLeader">
                <el-input
                  class="!w-full"
                  v-model="parentApiForm.orgLeader"
                  placeholder="请输入单位负责人"
                  size="small"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="邮箱" prop="email">
                <el-input
                  class="!w-full"
                  v-model="parentApiForm.email"
                  placeholder="请输入邮箱"
                  size="small"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属专业" prop="ownerdSpecialtyId">
                <el-select
                  v-model="parentApiForm.ownerdSpecialtyId"
                  filterable
                  placeholder="请选择所属专业"
                  clearable
                  disabled
                  class="w-full"
                >
                  <el-option
                    v-for="item in specialtyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="px-20px">
          <el-form
            :disabled="['read', 'approve'].includes(operateApiProps.editType)"
            size="mini"
            label-width="80px"
            v-loading="formLoading"
            :rules="apiRules"
            ref="apiForm"
            :model="apiForm"
            label-position="left"
          >
            <div :key="index" v-for="(typeItems, index) in sortAptitudeList">
              <div class="flex items-center ml-10px mb-5px">
                <span class="border-l-3 border-color-primary pl-10px text-18px">{{
                  typeItems.directoryName
                }}</span>
              </div>
              <!-- <el-divider content-position="left">
                <span class="text-16px font-600">{{ typeItems.directoryName }}</span>
              </el-divider> -->
              <!-- <h3 class="font-500 mb-5px">请将相关资质统一汇总到pdf文件中,并上传。</h3> -->
              <!-- <div class="text-gray-500  mb-5px">
            <span class="text-blue-500">示例文件下载</span
            >,请上传pdf问价或高清图片(jpg/png),大小不超过100M
          </div> -->
              <el-row class="px-20px flex flex-wrap">
                <!-- <el-col :span="8" class="">

                  <el-form-item
                    label-width="'100%"
                    :ref="typeItems.configurationDirectoryId"
                    label="文件上传"
                    :prop="`${typeItems.configurationDirectoryId}`"
                    :rules="[
                      { required: true, message: '请上传文件', trigger: ['blur', 'change'] },
                    ]"
                    class="flex flex-col"
                  >
                    <FormUpload :key="typeItems.configurationDirectoryId"
                      v-model="apiForm[`${typeItems.configurationDirectoryId}`]"
                      :disabled="['read', 'approve'].includes(operateApiProps.editType)"
                      :accept="['pdf', 'jpg', 'png', 'zip']"
                      @change="fileIdChange(typeItems.configurationDirectoryId)"
                      class="mt-10px"
                    />
                  </el-form-item>
                </el-col> -->

                <el-col
                  :span="8"
                  :key="ind"
                  v-for="(item, ind) in typeItems.child"
                  class=" pr-20px mb-20px "
                >
                  <div class="mb-10px">
                    <span v-show="!!item.isRequired" class="text-red-600">*</span
                    >{{ `${ind + 1}.${item.title}` }}
                  </div>
                  <div class="mb-10px">{{ item.titleContent }}</div>
                  <el-form-item label="是否提供" :prop="item.configurationId">
                    <el-radio-group
                      v-model="apiForm[item.configurationId]"
                      @input="(e) => handleIsSupply(e, item)"
                    >
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    v-if="apiForm[item.configurationId]"
                    label-width="80px"
                    :ref="`${item.id}`"
                    label="文件上传"
                    :prop="`${item.id}`"
                    :class="{
                      'flex flex-col':
                        !['read', 'approve', 'edit', 'create'].includes(operateApiProps.editType) &&
                        apiForm[`${item.id}`],
                    }"
                  >
                    <FormUpload
                      :disabled="['read', 'approve'].includes(operateApiProps.editType)"
                      v-model="apiForm[`${item.id}`]"
                      :accept="['pdf', 'jpg', 'png', 'zip']"
                      @change="fileIdChange(`${item.id}`)"
                    />
                  </el-form-item>

                  <el-form-item
                    v-if="!apiForm[item.configurationId]"
                    :prop="`${item.configurationId}explain`"
                    label="说明"
                    :rules="[{ required: true, message: '说明不能为空', trigger: 'blur' }]"
                  >
                    <el-input
                      show-word-limit
                      maxlength="50"
                      v-model="apiForm[`${item.configurationId}explain`]"
                      placeholder="请输入说明"
                    ></el-input>
                  </el-form-item>
                  <!-- :rules="[
                      { required: true, message: '请选择资质类别', trigger: ['blur', 'change'] },
                    ]" -->
                  <el-form-item label="资质类别" :prop="`${item.configurationId}directoryId`">
                    <el-select
                      size="small"
                      class="w-full"
                      filterable
                      clearable
                      placeholder="请选择资质类别"
                      v-model="apiForm[`${item.configurationId}directoryId`]"
                    >
                      <el-option
                        v-for="typeItem in workPermitCategoryList"
                        :key="Number(typeItem.code)"
                        :label="typeItem.displayName"
                        :value="Number(typeItem.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="有效期" :prop="`${item.configurationId}date`">
                    <el-date-picker
                      class="!w-full"
                      v-model="apiForm[`${item.configurationId}date`]"
                      type="daterange"
                      size="small"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="证书编号" :prop="`${item.configurationId}number`">
                    <el-input
                      size="small"
                      placeholder="请输入证书编号"
                      v-model="apiForm[`${item.configurationId}number`]"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
      </div>
      <div class="flex justify-center mt-20px" v-if="operateApiProps.editType !== 'read'">
        <el-button
          size="small"
          type="primary"
          @click="save()"
          v-if="operateApiProps.editType === 'edit' || operateApiProps.editType === 'create'"
          >保存</el-button
        >
        <el-button
          v-if="operateApiProps.editType === 'approve'"
          type="primary"
          size="small"
          @click="openApproveDailog"
          >审批</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="cancel">取消</el-button>
      </div>
      <div
        slot="footer"
        class="dialog-footer flex justify-center items-center"
        v-if="!(operateApiProps.editType === 'read')"
      ></div>
    </div>
    <!-- 审批弹窗 -->
    <el-dialog
      v-if="visible"
      :close-on-click-modal="false"
      title="审批"
      :visible.sync="visible"
      class="small-dialog"
      v-dialogDrag
      append-to-body
    >
      <el-form ref="checkResultForm" label-width="150px" :model="checkResultForm">
        <el-form-item
          label="审批结果"
          prop="isPass"
          :rules="[{ required: true, message: '请选择审批结果', trigger: 'blur' }]"
        >
          <el-radio-group v-model="checkResultForm.isPass">
            <el-radio :label="true">审批通过</el-radio>
            <el-radio :label="false">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="审批意见"
          prop="approve"
          :rules="[{ required: true, message: '请输入审批意见', trigger: 'blur' }]"
        >
          <el-input
            v-model="checkResultForm.approve"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" @click="handleSaveResult" :loading="cardLoading"
          >保存</el-button
        >
        <el-button size="small" @click="cancelResult">取消</el-button>
      </div>
    </el-dialog>

    <!-- 流程弹窗 -->
    <ApprovalFlowDialog
      :visible.sync="approvalFlowDialog"
      v-if="approvalFlowDialog"
      :id="flowTaskId"
      @cancel="approvalFlowDialog = false"
    >
    </ApprovalFlowDialog>
  </el-card>
</template>

<script>
import utils from '@/components/safety/enumField/utils'
import {
  WorkPermitApi,
  ContractorApi,
  WorkPermitGuidanceConfigurationDirectoryApi,
  ProfileTemplateGuidanceConfigurationApi,
  WorkPermitGuidanceFileApi,
} from '@wiz-api/contractor-management'
import { SpecialtyApi } from '@wiz-api/team-management'
import dayjs from 'dayjs'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'

const contractorApi = new ContractorApi()
const workPermitApi = new WorkPermitApi()
const workPermitGuidanceFileApi = new WorkPermitGuidanceFileApi()
const workPermitGuidanceConfigurationDirectoryApi = new WorkPermitGuidanceConfigurationDirectoryApi()
const profileTemplateGuidanceConfigurationApi = new ProfileTemplateGuidanceConfigurationApi()
const specialtyApi = new SpecialtyApi()

const FormUpload = () => {
  return import('@/components/safety/FileUpload/FormUpload')
}

export default {
  name: 'operate-api-dialog',
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    operateApiProps: {
      type: Object,
      default: () => {
        return {
          title: '新增api',
          editType: 'create',
          visible: false,
        }
      },
    },
    templateId: {
      default: null,
    },
    permitsId: {
      default: null,
    },
    contractorId: {
      default: null,
    },
    flowTaskId: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    FormUpload,
    ApprovalFlowDialog,
  },
  watch: {
    // visible(val) {
    //   if (!val) {
    //     this.$emit('cancel')
    //   }
    // },
    contractorId: {
      handler(val) {
        this.getContractorInfo()
      },
      immediate: true,
    },
    apiForm: {
      deep: true,
      handler(val) {},
      immediate: true,
    },
  },
  data() {
    return {
      workPermitCategoryList: [],
      specialtyList: [],
      approvalFlowDialog: false,
      checkResultForm: {
        isPass: true,
        approve: '',
      },
      visible: false,
      cardLoading: false,
      aptitudeList: [],
      apiForm: {},
      formLoading: false,

      parentApiForm: {},
      parentFormLoading: false,
      claimTypes: [], // 声明集
      initClaimTypes: [],

      parentApiRules: {},
      fileDtoMap: {},
    }
  },
  computed: {
    apiRules() {
      const strList = ['orgName', 'orgShortName', 'orgLeader', 'email', 'phoneNumber']
      const formRules = strList.reduce((pre, item) => {
        pre[item] = [{ required: true, message: '请输入', trigger: ['blur', 'change'] }]
        return pre
      }, {})
      return {
        // ...formRules,
        ...this.aptitudeList.reduce(
          (pre, item) => {
            pre[item.filed] = [
              {
                required: !!item.a4,
                message: '请输入名称',
                trigger: 'blur',
              },
            ]
            return pre
          },
          { name: [{ required: true, message: '请输入名称', trigger: 'blur' }] }
        ),
      }
    },
    sortAptitudeList() {
      const list = this.aptitudeList.reduce((pre, item) => {
        const child = pre.find((i) => {
          return i.directoryName === item.directoryName
        })
        if (!child || child === -1) {
          pre.push({
            id: item.id,
            configurationDirectoryId: item.directoryId || item.configurationDirectoryId,
            directoryName: item.directoryName,
            child: [item],
          })
        } else {
          child.child.push(item)
        }
        return pre
      }, [])
      return list
    },
  },
  methods: {
    viewFlow() {
      if (window.__POWERED_BY_QIANKUN__) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
      } else {
        this.approvalFlowDialog = true
      }
    },
    async getSpecialtyList() {
      const [err, res] = await specialtyApi.getSpecialtyDropDown()
      if (!err) {
        this.specialtyList = res
        this.specialtyList.unshift({ id: '00000000-0000-0000-0000-000000000000', name: '无专业' })
      }
    },
    // 打开审批
    openApproveDailog() {
      this.checkResultForm = this.$options.data().checkResultForm
      this.visible = true
    },
    // 取消审批
    cancelResult() {
      this.visible = false
    },
    // 审批
    handleSaveResult() {
      this.$refs.checkResultForm.validate(async (valid) => {
        if (valid) {
          this.cardLoading = true
          const [err, res] = await workPermitApi.approve({
            body: {
              id: this.permitsId,
              taskId: this.FormData.taskId,
              ...this.checkResultForm,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '审批成功',
              type: 'success',
            })
            this.visible = false
            this.$emit('refreshList')
          }
          this.cardLoading = true
        }
      })
    },
    fileIdChange(key) {
      this.$refs[key][0].$emit('el.form.change')
    },
    ridioInput(value, configurationId) {
      if (value) {
        this.apiForm[`${configurationId}explain`] = ''
      }
    },
    cancel() {
      this.$emit('cancel')
      // this.operateApiProps.visible = false
    },
    async save() {
      this.$refs.apiForm.validate(async (valid) => {
        if (valid) {
          if (this.operateApiProps.editType === 'create') {
            // contractorId 承包商id先写死
            const [err, res] = await workPermitApi.create({
              body: {
                contractorId: this.contractorId,
                applyTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              },
            })
            // 文件绑定
            // const list = this.sortAptitudeList.map((item) => {
            //   return {
            //     workPermitId: res.id,
            //     configurationDirectoryId: item.configurationDirectoryId,
            //     fileId: this.apiForm[item.configurationDirectoryId],
            //   }
            // })
            // const [fileErr, fileRes] = await workPermitGuidanceFileApi.insertMany({ body: list })
            // 表单绑定
            if (!err) {
              const [
                errList,
                resList,
              ] = await workPermitGuidanceConfigurationDirectoryApi.insertMany({
                body: this.dealForm(res.id),
              })
              if (!errList) {
                this.$message.success({
                  showClose: true,
                  message: '新增成功',
                })
                this.operateApiProps.visible = false
                this.$emit('refreshList')
              }
            }
            return
          }
          // 文件修改
          // const list = this.sortAptitudeList.map((item) => {
          //   return {
          //     id: this.fileDtoMap[item.configurationDirectoryId].id,
          //     workPermitId: this.permitsId,
          //     configurationDirectoryId: item.configurationDirectoryId,
          //     fileId: this.apiForm[item.configurationDirectoryId],
          //   }
          // })
          // const [fileErr, fileRes] = await workPermitGuidanceFileApi.updateMany({ body: list })
          const [err, res] = await workPermitGuidanceConfigurationDirectoryApi.updateMany({
            body: this.dealForm(),
          })
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '修改成功',
            })
            this.operateApiProps.visible = false
            this.$emit('refreshList')
          }
        }
      })
    },
    dealForm(id) {
      return this.aptitudeList.map((item) => {
        // const contractorId = id  // 承包商id

        const configurationDirectoryId = item.directoryId // 目录id
        const isProvided = this.apiForm[item.configurationId]
        const description = this.apiForm[`${item.configurationId}explain`]
        const workPermitId = id || this.permitsId // 承包商许可id
        return {
          workPermitId,
          configurationDirectoryId,
          ...item,
          categoryCode: this.apiForm[`${item.configurationId}directoryId`] || 0,
          description,
          isProvided,
          fileId: this.apiForm[item.id] === '' ? null : this.apiForm[item.id],
          number: this.apiForm[`${item.configurationId}number`],
          validDateBegin:
            (this.apiForm[`${item.configurationId}date`] &&
              this.apiForm[`${item.configurationId}date`].length &&
              dayjs(this.apiForm[`${item.configurationId}date`][0]).format(
                'YYYY-MM-DD HH:mm:ss'
              )) ||
            null,
          validDateEnd:
            (this.apiForm[`${item.configurationId}date`] &&
              this.apiForm[`${item.configurationId}date`].length &&
              dayjs(this.apiForm[`${item.configurationId}date`][1]).format(
                'YYYY-MM-DD HH:mm:ss'
              )) ||
            null,
        }
      })
    },
    handleIsSupply(e, item) {
      // this.ridioInput(e, `${item.configurationId}`)
      if (e) {
        this.apiForm[`${item.configurationId}explain`] = ''
      } else {
        this.apiForm[`${item.id}`] = ''
      }
      this.$refs.apiForm.clearValidate([`${item.configurationId}explain`])
      this.$refs.apiForm.clearValidate([`${item.id}`])
    },
    setValue(result) {
      const form = {}
      result.forEach((item) => {
        // 新增默认所有都有
        form[item.configurationId] =
          this.operateApiProps.editType === 'create' ? true : !!item.isProvided
        form[`${item.configurationId}explain`] = item.description
        form[`${item.configurationId}number`] = item._number
        form[`${item.configurationId}directoryId`] =
          item.categoryCode === 0 ? '' : item.categoryCode

        form[`${item.configurationId}date`] = item.validDateBegin
          ? [dayjs(item.validDateBegin).format('YYYY-MM-DD'), dayjs(item.validDateEnd).format('YYYY-MM-DD')]
          : []

        form[item.id] = item.fileId
      })
      this.apiForm = form
    },
    async getFilesInfo() {
      const [err, res] = await workPermitGuidanceFileApi.getWorkPermitGuidanceFileDto({
        workPermitId: this.permitsId,
      })
      const form = {}
      if (!err) {
        this.fileDtoMap = res.reduce((pre, item) => {
          pre[item.configurationDirectoryId] = item
          return pre
        }, {})
        res.forEach((item) => {
          if (item.fileId) {
            form[item.configurationDirectoryId] = item.fileId
          }
        })
      }
      this.apiForm = { ...this.apiForm, ...form }
    },
    async getConfig() {
      let result
      if (this.operateApiProps.editType === 'create') {
        const [
          err,
          res,
        ] = await profileTemplateGuidanceConfigurationApi.profileTemplateGuidanceConfigurationList({
          templateId: this.templateId,
        })
        result = res
      } else {
        const [
          err,
          res,
        ] = await workPermitGuidanceConfigurationDirectoryApi.profileWorkPermitGuidanceConfigurationDirectory(
          {
            workPermitId: this.permitsId,
          }
        )
        result = res
        // const hasFileId = _.filter(res, (item) => {
        //   return item.fileId
        // })
        // const hasNullFileId = _.filter(res, (item) => {
        //   return !item.fileId
        // })
        // result = [...hasFileId, ...hasNullFileId]
      }
      this.setValue(result)
      this.aptitudeList = result
      this.getFilesInfo()
    },
    async getContractorInfo() {
      if (!this.contractorId) return
      this.parentFormLoading = true
      const [err, res] = await contractorApi.get(this.contractorId)
      this.parentFormLoading = false
      this.parentApiForm = res
    },
  },
  async created() {
    await utils.getDataCategory(
      ['ContractorManagement.DataCategory.WorkPermitCategory'],
      ['workPermitCategoryList'],
      this
    )
    this.getConfig()
    this.getSpecialtyList()
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
